import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import PURCHASEIRQDisabledVeteranView from "../views/IrqDisabledVeteranView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object, bool } from "yup";
import StatusCheck from "../components/StatusCheck";

class PurchaseIrqDisabledVeteranPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="purchaseIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            disabledVeteran: bool().required(),
          })}
        >
          <PURCHASEIRQDisabledVeteranView
            content={contentMap.PurchaseIrqDisabledVeteranPage}
            navigationsAway={customNavigationMap.PurchaseIrqDisabledVeteranPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(PurchaseIrqDisabledVeteranPage);
